<app-card-table [info]=info></app-card-table>